module.exports = __webpack_public_path__ + "img/playlist.7b37652a.svg";